import React, { useState } from 'react';
import axios from 'axios';
import { useSite } from '../useSite';

const API = process.env.REACT_APP_BACKEND_URL;
export const fieldClass =
  'w-full rounded-[2px] border border-tan bg-white px-4 py-3 text-[15px] text-cafe-noir placeholder:text-cafe-noir/40 focus:border-kombu-green focus:outline-none focus:ring-1 focus:ring-kombu-green';
export const labelClass = 'mb-2 block text-sm font-medium text-cafe-noir';

export const validity = (required, invalidEmail) => ({
  onInvalid: (e) => e.target.setCustomValidity(e.target.validity.typeMismatch ? invalidEmail : required),
  onInput: (e) => e.target.setCustomValidity(''),
});

const EMPTY = { name: '', email: '', comment: '', website: '' };

export const TestimonialForm = ({ className = 'mt-16 border-t border-tan/50 pt-14' }) => {
  const { t } = useSite();
  const tt = t.testimonials;
  const [data, setData] = useState(EMPTY);
  const [rating, setRating] = useState(5);
  const [state, setState] = useState({ busy: false, msg: '', ok: false });
  const set = (k) => (e) => setData({ ...data, [k]: e.target.value });
  const v = validity(tt.required, tt.invalidEmail);

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, msg: '', ok: false });
    try {
      await axios.post(`${API}/api/testimonials`, { ...data, rating }, { timeout: 30000 });
      setData(EMPTY);
      setRating(5);
      setState({ busy: false, msg: tt.success, ok: true });
    } catch (err) {
      setState({ busy: false, msg: tt.error, ok: false });
    }
  };

  return (
    <div className={`grid gap-10 md:grid-cols-12 ${className}`}>
      <div className="md:col-span-4">
        <h3 className="font-serif text-2xl text-kombu-green">{tt.formTitle}</h3>
        <p className="mt-3 text-sm text-cafe-noir/70">{tt.formText}</p>
      </div>
      <form onSubmit={submit} className="space-y-5 md:col-span-8" data-testid="testimonial-form">
        <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" className="hp-field" value={data.website} onChange={set('website')} />
        <div className="grid gap-5 sm:grid-cols-2">
          <label className="block"><span className={labelClass}>{tt.name}</span>
            <input data-testid="testimonial-name-input" required {...v} maxLength={100} value={data.name} onChange={set('name')} className={fieldClass} />
          </label>
          <label className="block"><span className={labelClass}>{tt.email}</span>
            <input data-testid="testimonial-email-input" type="email" required {...v} value={data.email} onChange={set('email')} className={fieldClass} />
          </label>
        </div>
        <label className="block"><span className={labelClass}>{tt.comment}</span>
          <textarea data-testid="testimonial-comment-input" required {...v} minLength={2} maxLength={2000} rows={4} value={data.comment} onChange={set('comment')} placeholder={tt.commentPlaceholder} className={fieldClass} />
        </label>
        <div>
          <span className={labelClass}>{tt.rating}</span>
          <div className="flex gap-1" data-testid="testimonial-rating-stars">
            {[1, 2, 3, 4, 5].map((s) => (
              <button key={s} type="button" aria-label={`${s}/5`} data-testid={`testimonial-rating-star-${s}`} onClick={() => setRating(s)}
                className={`text-3xl transition-colors ${s <= rating ? 'text-moss-green' : 'text-tan hover:text-moss-green'}`}>★</button>
            ))}
          </div>
        </div>
        {state.msg && <p role="status" data-testid="testimonial-form-status" className={`text-sm ${state.ok ? 'text-kombu-green' : 'text-red-700'}`}>{state.msg}</p>}
        <button type="submit" disabled={state.busy} data-testid="testimonial-submit-btn"
          className="rounded-[2px] bg-kombu-green px-6 py-3.5 text-sm font-semibold text-bone-light transition-colors hover:bg-kombu-green-dark disabled:opacity-60">
          {state.busy ? tt.sending : tt.submit}
        </button>
      </form>
    </div>
  );
};
